import BannerService from '@engoo/banner-service';
import Logger from 'app/services/logger';
import React, { createContext, FunctionComponent, useContext, useRef } from 'react';

const Context = createContext<BannerService | undefined>(undefined);

interface IProviderProps {
  bannerService?: BannerService;
}

export const BannerServiceProvider: FunctionComponent<IProviderProps> = ({ bannerService, children }) => {
  return React.createElement(Context.Provider, { children, value: bannerService });
};

export const useBannerService = (): BannerService | undefined => {
  const bannerService = useContext(Context);
  const warning = useRef(false);

  if (warning.current === false && !bannerService) {
    Logger.warn('No banner service found.');
  }

  return bannerService;
};
